import React from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCog,
  faLock,
  faSync,
  faTrash,
} from '@fortawesome/pro-solid-svg-icons'

import { useTranslationRankmi } from 'helpers/translations.helper'
import { WarningModalHeader } from 'components/ui/modals/WarningModalHeader'
import { prefix } from './constants'
import styles from './ActionsWhenEditing.module.scss'
import { ButtonAction, DeleteResults, ConfirmationReset } from './components'

interface ActionsOnEditProps {
  show: boolean
  onFinish: () => void
  onClose: any
}

export const ActionsOnEdit: React.FC<ActionsOnEditProps> = ({
  show,
  onFinish,
  onClose,
}) => {
  const t = useTranslationRankmi({
    prefix,
  })

  const [reset, setReset] = React.useState(false)
  const [deleteResults, setDeleteResults] = React.useState(false)

  const openSubModal = reset || deleteResults

  const onCloseReset = () => {
    setReset(false)
  }
  const onCloseDeleteResults = () => {
    setDeleteResults(false)
  }

  return (
    <>
      <Modal
        show={show && !openSubModal}
        size={'lg'}
        centered
        className={styles.modalContainer}
        onHide={onClose}
      >
        <WarningModalHeader translate="yes" closeButton>
          <FontAwesomeIcon icon={faCog} />
          <h1 className="title">{t('title')}</h1>
        </WarningModalHeader>
        <Modal.Body className="px-4">
          <div className="mb-3">{t('description')}</div>
          <Row className="d-flex justify-content-center px-md-1">
            <Col xs={12} lg={4} className="mt-1">
              <ButtonAction
                onClick={() => {
                  setReset(true)
                }}
                text={t('buttons.reset.text')}
                tooltip={t('buttons.reset.tooltip')}
                icon={faSync}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-1">
              <ButtonAction
                onClick={() => {
                  setDeleteResults(true)
                }}
                text={t('buttons.delete.text')}
                tooltip={t('buttons.delete.tooltip')}
                icon={faTrash}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-1">
              <ButtonAction
                onClick={() => {
                  onFinish()
                  onClose()
                }}
                text={t('buttons.keep.text')}
                tooltip={t('buttons.keep.tooltip')}
                icon={faLock}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <ConfirmationReset
        show={reset}
        onSuccess={() => {
          onCloseReset()
          onFinish()
        }}
        onClose={onCloseReset}
      />
      <DeleteResults
        show={deleteResults}
        onSuccess={() => {
          onFinish()
        }}
        onClose={onCloseDeleteResults}
      />
    </>
  )
}

export default ActionsOnEdit
